import React, { Component } from 'react';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import gtag, { install } from 'ga-gtag';

// ユーザー特定のための乱数生成
const l = 16;
const c = "abcdefghijklmnopqrstuvwxyz0123456789";
const cl = c.length;
let r = "";
for(let i=0; i<l; i++) {
  r += c[Math.floor(Math.random()*cl)];
}
const uuid = r

export default class Web extends Component {

  constructor (props) {
    super(props);

    this.state = {
      image: 0,
      next: 1,
      images: ["/images/homepage/top_image_1.jpg", "/images/homepage/top_image_2.jpg", "/images/homepage/top_image_3.jpg", "/images/homepage/top_image_4.jpg"],
      opacitys: [1, 0, 0, 0]
    };
  }

  componentDidMount () {
    if (this.props.match.params.section) {
      window.scrollTo(0, 100);
    }
    if ("30min.page" === document.domain) {
      ReactGA.initialize('UA-184751599-1', {gaOptions: {userId: uuid}});
      ReactGA.pageview(window.location.pathname + window.location.search);

      install('AW-404081375');
      gtag('config', 'AW-404081375');
      
      ReactPixel.init('750234562329469');
      ReactPixel.pageView();
    }

    var scope = this
    let i = 0;
    var opacitys = scope.state.opacitys
    const slide = () => {
      const slide_opacity = () => {
        i += 0.05
        opacitys[scope.state.image] = 1 - i
        opacitys[scope.state.next] = i
        scope.setState({opacitys: opacitys})
        const timeoutId = setTimeout(slide_opacity, 50)
        if (i > 1) {
          i = 0
          let next = scope.state.next
          next++
          if (scope.state.images.length <= next) {
            next = 0
          }
          let image = scope.state.image
          image++
          if (scope.state.images.length <= image) {
            image = 0
          }
          scope.setState({image: image, next: next})
          clearTimeout(timeoutId);
        }
      }
      slide_opacity()
      setTimeout(slide, 5000)
    }
    slide()
  }

  send() {
    window.location.href = "https://30min-7085787.hs-sites.com/%E4%BA%8B%E5%89%8D%E7%99%BB%E9%8C%B2-0-0";
  }

  inquiry() {
    window.location.href = "mailto:thirty-min@mec.co.jp";
  }

  covid() {
    window.location.href = "https://f.hubspotusercontent30.net/hubfs/7085787/%E6%96%B0%E5%9E%8B%E3%82%B3%E3%83%AD%E3%83%8A%E3%82%A6%E3%82%A3%E3%83%AB%E3%82%B9%E3%81%AB%E4%BF%82%E3%82%8B%E5%AF%BE%E5%BF%9C%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6.pdf"
  }

  render () {
    return (
    <div className="web home">
      <div className="content-wrapper">
        <div className="homepage">

          <div className="header">
            <div className="logo">
              <img src="/images/homepage/logo.png" alt="" />
            </div>
            <nav className="mec-nav">
              <img src="/images/homepage/mitsubishi_jisyo.png" alt="" />
            </nav>
            <nav className="global-nav">
              <ul>
                <li><a href="#news">お知らせ</a></li>
                <li><a href="#service">サービス</a></li>
                <li><a href="#courses_and_fees">コース・料金</a></li>
                <li><a href="#faq">よくある質問</a></li>
                <li><a href="https://30min-7085787.hs-sites.com/%E4%BA%8B%E5%89%8D%E7%99%BB%E9%8C%B2-0-0">事前登録</a></li>
                <li><a href="mailto:thirty-min@mec.co.jp">お問い合わせ</a></li>
              </ul>
            </nav>
          </div>

          <div className="news-articles background-white" id="news">
            <div className="news-header">
              <div>
                <img className="title-img" src="/images/homepage/heading_news.png" alt="" />
              </div>
            </div>
            <div className="news-nav">
              <a href="/">TOP</a> > NEWS
            </div>
            <div className="news-article">
              <div className="date">2021.10.08</div>
              <div className="tag">お知らせ</div>
              <div className="title"><a href="/news/1">10/8　三菱地所の家事代行「30min.」ローンチいたしました！</a></div>
            </div>
            <div className="body">
              三菱地所の家事代行サービス「30min.」がローンチいたしました。<br />
              皆様に、少しでも手軽に・気軽に家事代行をつかっていただきた、そんな想いから生まれた三菱地所の新規事業となります。<br />
              徐々に展開エリアを拡大予定ですので、是非「事前登録」をお願いいたします。<br />
              <br />
              三菱地所からのプレスリリースはこちら
            </div>
          </div>

          <div className="footer">
            <ul>
              <li>特定商取引に基づく表記</li>
              <li>プライバシーポリシー</li>
              <li>運営会社</li>
            </ul>
            <div className="cv-button">
              <button onClick={this.inquiry.bind(this)} className="background6">お問い合わせはコチラ</button>
            </div>
            <img src="/images/homepage/logo.png" alt="" />
            <div className="text-4">Copyright © MITSUBISHI ESTATE Co., Ltd. All Rights Reserved.</div>
          </div>

          <div className="content">
            <img className="phrase_logo" src="/images/homepage/mitsubishi_jisyo_phrase.png" alt="" />
            <div className="cv-button">
              <button onClick={this.send.bind(this)} className="background7">事前登録はコチラ</button>
            </div>
          </div>

        </div>
      </div>
    </div>
    );
  }
}